import React from 'react'

function Orders() {
    return (
        <div>
            Welcome to Orders
        </div>
    )
}

export default Orders
